// extracted by mini-css-extract-plugin
export var container = "_86-0";